import Text from './text'
import imageSrc from './imageSrc'
import videoSrc from './videoSrc'
import imageSrcList from './imageSrcList'
import Url from './url'
import musicSrc from './musicSrc'

export default {
	[Text.name]: Text,
	[imageSrc.name]: imageSrc,
	[videoSrc.name]: videoSrc,
	[Url.name]: Url,
	[musicSrc.name]: musicSrc,
	[imageSrcList.name]: imageSrcList
}
